import styles from "./InboxView.module.scss";
import { View, ViewHeader } from "@/components";

export const InboxView = () => {
  return (
    <View>
      <div className={styles["comp__content"]}>
        <ViewHeader
          heading="Inbox"
          description="Manage all incoming communication and submissions in one place.<br />Open Forms, Email, or Chat to review specific channels."
        />
      </div>
    </View>
  );
};
